export { AuthorName, AuthorPosition } from './Author';
export { AuthorAvatar, AuthorInfo } from './Author.views';